import styled from 'styled-components'
import { type ProductCardProduct } from '@/features/shop/components/ProductCard/types'
import { useGetProductFlag } from '@/features/shop/services/Product/hooks'
import { FlagBadge } from '@/features/shared/elements/Badges'
import { SkeletonConsumer } from '@/features/shared/components/SkeletonLoader'

type Props = {
  product: ProductCardProduct
  className?: string
  limit?: number
}

export const ProductCardFlag = ({ product, className, limit, ...restProps }: Props) => {
  const badgeType = useGetProductFlag(product, limit)

  if (!badgeType) return null

  return (
    <SkeletonConsumer width={0} height={0}>
      <FlagContainer className={className} {...restProps}>
        <FlagBadge type={badgeType} limit={limit} />
      </FlagContainer>
    </SkeletonConsumer>
  )
}

const FlagContainer = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  z-index: 1;
`
